import { Nav, Sidenav } from "rsuite";
import { useSelector } from "react-redux";
import { getLocalization } from "../../redux/localization";
import LanguageDropdown from "./LanguageDropdown";
import { clientAppUrl } from "../../redux/base/types/url";

const MobileNavbarMenu = ({
  showMenu,
  setShowMenu,
  onSelect,
  active,
}: {
  active: string;
  onSelect: (eventKey: string) => void;
  showMenu: boolean;
  setShowMenu: (show: boolean) => void;
}) => {
  const t = useSelector(getLocalization);
  return (
    <section
      className={
        showMenu ? "drawerSection drawerSectionActive" : "drawerSection "
      }
    >
      <Sidenav style={{ backgroundColor: "white" }}>
        <Sidenav.Body className="sm-navbarSideMenu">
          <Nav
            className="mb-0"
            activeKey={active}
            onSelect={(eventkey) => {
              onSelect(eventkey);
              return setShowMenu(false);
            }}
          >
            <Nav.Item eventKey="" href={"/"}>{t.getString("Home")}</Nav.Item>
            <Nav.Item eventKey="/solutions" href={"/solutions/"}>
              {t.getString("Solutions")}
            </Nav.Item>
            <Nav.Item eventKey="/features" href={"/features/"}>
              {t.getString("Features")}
            </Nav.Item>
            <Nav.Item eventKey="/pricing" href={"/pricing/"}>{t.getString("Pricing")}</Nav.Item>
            <Nav.Item eventKey="contactus" href={"/contactus/"}>
              {t.getString("Contact Us")}
            </Nav.Item>
            <Nav.Item eventKey="/help" href={"/help/"}>
              {t.getString("Help")}
            </Nav.Item>
          </Nav>
        
        </Sidenav.Body>
      </Sidenav>
    </section>
  );
};
export default MobileNavbarMenu;
